import  { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { faqs } from '../data/Faqs';


const FAQ = () => {
  const [openCategory, setOpenCategory] = useState<string | null>("Préstamos");
  const [openQuestions, setOpenQuestions] = useState<number[]>([]);

  const toggleQuestion = (index: number) => {
    setOpenQuestions(prev =>
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-navy-900 mb-4">Frequently asked questions</h1>
        <p className="text-navy-700">
          Find the answers to the most Frequently asked questions about our products
        </p>
      </div>

      <div className="space-y-6">
        {faqs.map((category, categoryIndex) => (
          <motion.div
            key={category.category}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="border rounded-lg overflow-hidden"
          >
            <button
              className={`w-full px-6 py-4 text-left font-semibold flex justify-between items-center ${
                openCategory === category.category ? 'bg-navy-800 text-white' : 'bg-gray-50'
              }`}
              onClick={() => setOpenCategory(
                openCategory === category.category ? null : category.category
              )}
            >
              {category.category}
              {openCategory === category.category ? (
                <ChevronUp className="w-5 h-5" />
              ) : (
                <ChevronDown className="w-5 h-5" />
              )}
            </button>

            <AnimatePresence>
              {openCategory === category.category && (
                <motion.div
                  initial={{ height: 0 }}
                  animate={{ height: "auto" }}
                  exit={{ height: 0 }}
                  transition={{ duration: 0.3 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 py-4 space-y-4">
                    {category.questions.map((faq, index) => {
                      const questionIndex = categoryIndex * 100 + index;
                      return (
                        <div key={index} className="border-b border-gray-200 last:border-0">
                          <button
                            className="w-full py-4 text-left flex justify-between items-center"
                            onClick={() => toggleQuestion(questionIndex)}
                          >
                            <span className="font-medium">{faq.question}</span>
                            {openQuestions.includes(questionIndex) ? (
                              <ChevronUp className="w-5 h-5 text-gray-500" />
                            ) : (
                              <ChevronDown className="w-5 h-5 text-gray-500" />
                            )}
                          </button>
                          <AnimatePresence>
                            {openQuestions.includes(questionIndex) && (
                              <motion.div
                                initial={{ height: 0 }}
                                animate={{ height: "auto" }}
                                exit={{ height: 0 }}
                                transition={{ duration: 0.3 }}
                                className="overflow-hidden"
                              >
                                <p className="pb-4 text-gray-600">
                                  {faq.answer}
                                </p>
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </div>
                      );
                    })}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export default FAQ;